<template>
  <div class="sleepwalking">
    <img src="../assets/sleepwalkinglogo.png" alt="logo" />
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";

const Sleepwalking = defineComponent({
  name: "Sleepwalking"
});

export default Sleepwalking;
</script>

<style lang="scss">
.sleepwalking {
  box-sizing: border-box;
  // width: 180px;
  width: 60px;
  margin: 0 auto;
  margin-top: 40px;
  padding: 4px;
  height: 60px;
  border-radius: 30px; //10px;
  background-color: white;
  border: 1px solid rgba(102, 0, 159, 0.2);
  img[alt="logo"] {
    width: 50px;
    margin-top: 20px;
  }
}

.sleepwalking:active {
  box-shadow: inset 0 0 6px 2px #eaeaea;
}
</style>
